import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustedLogos from '../components/TrustedLogos';
import TechnologyTabs from '../components/TechnologyTabs';
import Outcomes from '../components/Outcomes';
import GlobalScale from '../components/GlobalScale';
import CustomerStories from '../components/CustomerStories';
import MediaSplits from '../components/MediaSplits';
import InsideCisco from '../components/InsideCisco';
import NextSteps from '../components/NextSteps';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <TrustedLogos />
        <TechnologyTabs />
        <Outcomes />
        <GlobalScale />
        <CustomerStories />
        <MediaSplits />
        <InsideCisco />
        <NextSteps />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default Home;
